/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {retractCustomerBio} from '../api'

export const useMutationRetractCustomerBio = createReactQueryMutationHook('retractCustomerBio', retractCustomerBio)
